<div class="navbar navbar-expand-lg rsx-nav-header bg-primary nav-container">
  <div
    class="container gap-7 py-4 py-md-8 justify-content-start nav-container__inner-container flex-nowrap align-items-center"
  >
    <digital-platform-nav-header
      class="nav-container__header"
      [mobileHeaderTitle]="mobileHeaderTitle"
      [mobileNavOpen]="mobileNavOpen"
      [onBackClick]="
        navDropdownComponent.shouldNavBack.bind(navDropdownComponent)
      "
    ></digital-platform-nav-header>

    <digital-platform-desktop-nav-list
      class="nav-container__desktop-list"
      data-automation-id="meganav"
      [menuKeys]="menuKeys"
      [config]="config"
      [activeMenu]="activeMenu"
      (hoverStart)="startHover($event)"
      (hoverEnd)="endHover()"
    ></digital-platform-desktop-nav-list>

    <div class="nav-right-container" *ngIf="showCart">
      <div class="shop-cart-container">
        <a role="button" (click)="goToCartPage($event)">
          <digital-platform-icon
            icon="shopping-cart-outline"
            data-automation-id="cart-icon"
            color="white"
            [width]="24"
            [height]="24"
          ></digital-platform-icon>
          <div class="red-badge"></div>
        </a>
      </div>
    </div>

    <!-- Search Icon -->
    <digital-platform-desktop-nav-side-links
      *ngIf="!mobileNavOpen"
    ></digital-platform-desktop-nav-side-links>

    <!-- Desktop Nav Items -->
    <div class="nav-container__desktop-secondary ms-auto align-items-center">
      <ng-content select="[cart]"></ng-content>
      <ng-content select="[search]"></ng-content>
      <ng-content select="[login]"></ng-content>
    </div>

    <digital-platform-mobile-nav-toggle
      *ngIf="!isDesktop"
      [mobileNavOpen]="mobileNavOpen"
      (toggle)="toggleMobileNav()"
    ></digital-platform-mobile-nav-toggle>
  </div>
</div>
<div (mouseover)="resetHover()" (mouseout)="endHover()">
  <digital-platform-nav-dropdown
    [activeFirstMenu]="activeMenu"
    [(mobileNavOpen)]="mobileNavOpen"
    [menuKeys]="menuKeys"
    [icons]="icons"
    [config]="config"
    (stateReset)="clearBodyClass()"
    #navDropdownComponent
    (mobileHeaderTitle)="mobileHeaderTitle = $event"
  ></digital-platform-nav-dropdown>
</div>
